export const TITLE = {
  HOMEPAGE: "BrandSpire | Homepage",
  ABOUT_US: "BrandSpire | About us",
  CONTACT: "BrandSpire | Contact",
  BLOG: "BrandSpire | Blog",
  PORTFOLIO: "BrandSpire | Portfolio",
  SERVICES: "BrandSpire | Services",
};
